import ConfirmationDialog from "../ui/ConfirmationDialog";
import { useTranslation } from "react-i18next";

/**
 * DeletePersonaModal - Confirmation dialog for deleting a persona
 * @param {Object} props
 * @param {boolean} props.isOpen - Controls dialog visibility
 * @param {string} props.personaName - Name of the persona to delete
 * @param {Function} props.onConfirm - Callback when delete is confirmed
 * @param {Function} props.onCancel - Callback when delete is cancelled
 */
export default function DeletePersonaModal({ isOpen, personaName, onConfirm, onCancel }) {
  const { t } = useTranslation();
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      title={t("persona.deletePersonaTitle")}
      message={t("persona.deletePersonaMessage")}
      highlightText={personaName}
      subtitle={t("persona.deletePersonaSubtitle")}
      confirmText={t("common.delete")}
      cancelText={t("common.cancel")}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
